import { render, staticRenderFns } from "./AmbassadorForm.vue?vue&type=template&id=3b378336&lang=pug"
import script from "./AmbassadorForm.vue?vue&type=script&lang=js"
export * from "./AmbassadorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports